import React, { useEffect } from 'react';

import "./ShopCats.scss";
import { Router } from '../..';
import { shopBeam } from '../../../config/bifrost';
import { useBeam } from '@randajan/bifrost/client/react';
import { ShopCat } from './ShopCat/ShopCat';
import { ShopCat404 } from './ShopCat404/ShopCat404';

import tab from "@randajan/jet-react/base/tab";
import { LandingPage } from '../../LandingPage/LandingPage';

export const ShopCats = (props)=>{
    const { catId } = Router.useParams();

    const { data:shop } = useBeam(shopBeam);
    const cat = shop?.categories?.find(({webPath})=>webPath === catId);

    useEffect(_=>{
        tab.set("h1", { content:cat?.name, onTop:true });
    }, [cat]);

    return !shop?.isAuthorized ? <LandingPage/> : cat ? <ShopCat {...cat}/> : <ShopCat404/>
}

